import { useCallback } from "react";

import SpeechToTextRichTextInput from "../SpeechToText/SpeechToTextRichTextInput";
import RichText from "../Utils/RichText";
import withStringFormValue from "./withStringFormValue";
import { useModalContext } from "../Modals/Modal";

const WysiwygInput = props => {
  const { attachmentToken, disabled, labelNode, resourceId, updateStringValue, value } =
    props;

  const { contentRef: modalContentRef } = useModalContext();

  // When the editor is focused, scroll the modal content to ensure the editor is visible.
  // This is especially important for mobile, where the on-screen keyboard can cover a
  // large portion of the screen.
  const handleFocus = useCallback(
    e => {
      if (!modalContentRef.current) return;

      // Wait for the on-screen keyboard to appear (mobile) before measuring scroll
      // position, otherwise the layout hasn't shifted yet.
      setTimeout(() => {
        const scrollContainer = modalContentRef.current;
        const containerRect = scrollContainer.getBoundingClientRect();
        const editorRect = e.target.editorContainer.getBoundingClientRect();

        // getBoundingClientRect() is viewport-relative; convert to a scroll-container
        // absolute position by adding the container's current scroll offset.
        const scrollTop =
          scrollContainer.scrollTop + (editorRect.top - containerRect.top);

        scrollContainer.scrollTo({ behavior: "smooth", top: scrollTop });
      }, 0);
    },
    [modalContentRef]
  );

  // When the input is disabled, render the content as read-only rich text, instead of the
  // editor.
  if (disabled) {
    return <RichText className="padding-sm bg-light" content={value} />;
  }

  return (
    <SpeechToTextRichTextInput
      attachmentToken={attachmentToken}
      labelNode={labelNode}
      resourceId={resourceId}
      value={value}
      onChange={updateStringValue}
      onFocus={handleFocus}
    />
  );
};

export default withStringFormValue(WysiwygInput);
